import React, { useState, useEffect } from 'react';
import {
    Dialog,
    Button,
    Box,
    Avatar
} from '@mui/material';
import { MdClose } from 'react-icons/md';
import dayjs from 'dayjs';

const ViewSales = ({ open, onClose, data }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: '16px' } }}
        >
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">View Sales</h6>
                    <button type="button" className="btn btn-sm btn-light p-1 d-flex justify-content-center align-items-center" onClick={onClose}>
                        <MdClose size={18} />
                    </button>
                </div>

                <div className="card-body">

                    <span class="badge text-bg-light d-flex text-sm  p-3 align-items-center justify-content-between flex-wrap"><span>#{data?._id}</span><span>{dayjs(data?.createdAt).format('DD MMM YYYY hh:mm A')}</span></span>
                    <div className="d-flex align-items-center mt-3">
                        <Avatar
                            src={data?.user_id?.profile_photo}
                            alt=""
                            className="w-40-px h-40-px rounded-circle me-12"
                        />
                        <span className="text-md">{data?.user_id?.user_name}</span>
                    </div>
                    <div className="row gy-3 mb-3 mt-1">
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Email</label>
                            <span className="d-block">{data?.user_id?.email || "-"}</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Phone Number.</label>
                            <span className="d-block">{data?.user_id?.phone_number || "-"}</span>
                        </div>
                    </div>

                    <b className='mt-3'>Plan Details</b>
                    <div className="row gy-3">
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Title</label>
                            <span className="d-block">{data?.plan_id?.title || "-"}</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Description</label>
                            <span className="d-block">{data?.plan_id?.description || "-"}</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Duration</label>
                            <span className="d-block">{data?.plan_id?.duration_in_days} Days</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Amount</label>
                            <span className="d-block">₹{data?.amount}</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Payment Method</label>
                            <span className="d-block">{data?.payment_method || "-"}</span>
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <label className="form-label mb-1">Status</label>
                            <span
                                className={`badge rounded-pill ${data?.status === 'paid' ? 'bg-success' : 'bg-danger'}`}
                                style={{ width: 'min-content' }}
                            >
                                {data?.status}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    );
};

export default ViewSales;
